import { Typography, Box } from "@mui/material";

const HelpCenter = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Trung tâm Trợ giúp
      </Typography>
      <Typography variant="body1">Trang hướng dẫn và hỗ trợ.</Typography>
    </Box>
  );
};

export default HelpCenter;
